export class NovaTarefa {
  descricao: string;
  valor: number;
  tipoTarefaId: number;
  processoId: number | null;
  atendimentoId: number | null;
  dataPrevisaoFinalizacao: Date;
  dataInicial: Date;
  dataFinalizacao: Date;
  status: number | null;
}
